/* eslint-disable prettier/prettier */
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import moment from 'moment'

const MonthWiseOrdersChart = (props) => {

  const categories = props?.finalData?.map((item) => moment(item.month).format('MMM, YY'))
  const numberOfOrders = props?.finalData?.map((item) => item.number_of_orders)
  const totalOrdersAmount = props?.finalData?.map((item) => item.total_orders_amount)

  const options = {
    chart: {
      type: 'column',
      height: 500,
      className: 'shadow-lg rounded-lg bg-white p-4'
    },
    title: {
      text: '',
      style: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        fontFamily: 'inherit'
      }
    },
    xAxis: {
      categories: categories,
      crosshair: true,
      title: {
        text: 'Month'
      }
    },
    yAxis: [
      {
        title: {
          text: 'Number of Orders'
        },
        min: 0
      },
      {
        title: {
          text: 'Total Amount ($)'
        },
        opposite: true
      }
    ],
    tooltip: {
      shared: true,
      formatter: function () {
        let tooltip = `<b>${this.x} 2025</b><br/>`
        this.points.forEach((point) => {
          if (point.series.name === 'Number of Orders') {
            tooltip += `${point.series.name}: <b>${point.y}</b><br/>`
          } else {
            tooltip += `${point.series.name}: <b>$${point.y.toLocaleString()}</b><br/>`
          }
        })
        return tooltip
      }
    },
    plotOptions: {
      column: {
        borderRadius: 5,
        pointPadding: 0.1,
        groupPadding: 0.1
      }
    },
    series: [
      {
        name: 'Number of Orders',
        type: 'column',
        data: numberOfOrders,
        color: '#3B82F6', // blue
        yAxis: 0
      },
      {
        name: 'Total Orders Amount',
        type: 'line',
        data: totalOrdersAmount,
        color: '#10B981', // green
        yAxis: 1,
        marker: {
          symbol: 'circle',
          radius: 6,
          fillColor: '#FFFFFF',
          lineWidth: 2,
          lineColor: '#10B981'
        }
      }
    ],
    credits: {
      enabled: false
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }
      ]
    }
  }

  return (
    <div className="">
      <div className="overflow-hidden rounded-lg bg-white shadow">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  )
}

export default MonthWiseOrdersChart
